import { render, staticRenderFns } from "./AddUnavailabilitySvg.vue?vue&type=template&id=97ebf224&scoped=true&"
var script = {}
import style0 from "./AddUnavailabilitySvg.vue?vue&type=style&index=0&id=97ebf224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ebf224",
  null
  
)

export default component.exports